import { render, staticRenderFns } from "./InvestmentsTable.vue?vue&type=template&id=2521be04&"
import script from "./InvestmentsTable.vue?vue&type=script&lang=js&"
export * from "./InvestmentsTable.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentsTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports